import React, { Component } from 'react';
import { Grid, Row, Col, Image } from 'react-bootstrap';
import { UIAPI } from '../api/files/UIAPI';

export class Footer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            imageUrl: undefined
        };

        this.getImageUrl();
    }

    getImageUrl() {
        new UIAPI().getFooter()
            .then((result) => {
                this.setState({
                    imageUrl: JSON.parse(result)
                });
            })
            .catch(() => {
                this.setState({
                    imageUrl: undefined
                })
            });
    }

    render() {
        const { imageUrl } = this.state;

        if (undefined === imageUrl) {
            return null;
        }
        return (
            <div className="margin-top-15">
                <hr />
                <Grid fluid className="footer">
                    <Row>
                        <Col>
                            <Image src={imageUrl} />
                        </Col>
                    </Row>
                </Grid>
            </div>
        )
    }
}